import { useEffect } from "react";

export const SITE_URL = "https://oceanoasis.llc";

const DEFAULT_IMAGE =
  "https://images.unsplash.com/photo-1763454310351-abd6b81167bb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export const ORG_JSONLD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Ocean Oasis",
  alternateName: "Ocean Oasis Group",
  url: SITE_URL,
  logo: "https://customer-assets.emergentagent.com/job_ocean-hub-mogadishu/artifacts/jjje549r_Common_Logo-removebg-preview-removebg-preview.png",
  description:
    "Ocean Oasis is a Somali-owned group operating a premium supermarket, an international logistics company and a specialty coffee house from Sundus Plaza, Bondhere District, Mogadishu, Somalia.",
  telephone: "+252610424241",
  email: "info@oceanoasis.llc",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Sundus Plaza, Bondhere District",
    addressLocality: "Mogadishu",
    addressCountry: "SO",
  },
};

export default function Seo({ title, description, path = "/", image, jsonLd }) {
  const url = `${SITE_URL}${path === "/" ? "/" : path}`;
  const img = image || DEFAULT_IMAGE;
  const json = jsonLd ? JSON.stringify(jsonLd) : null;

  useEffect(() => {
    if (!json) return;
    const items = JSON.parse(json);
    const scripts = (Array.isArray(items) ? items : [items]).map((data) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.text = JSON.stringify(data);
      document.head.appendChild(s);
      return s;
    });
    return () => scripts.forEach((s) => s.remove());
  }, [json]);

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Ocean Oasis" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="en_US" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
    </>
  );
}
